import * as React from "react";
import {
  TextField,
  FunctionField,
  DateField,
  TextInput,
  SelectInput,
  NumberField,
  EditButton,
  BooleanField
} from "react-admin";
import { StockTypeEnum, StockSupplierEnum } from "src/common/enum";
import { Datagrid, List, IfCanAccess } from "src/enterprise/ra-rbac";
import { DateRangeInput } from "src/components/input";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <SelectInput source="type" choices={StockTypeEnum} />,
  <SelectInput source="supplier" choices={StockSupplierEnum} />,
  <DateRangeInput source="incoming_at" label="Incoming At" />,
];

export const StockList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }} sort={{ field: 'id', order: 'DESC' }}>
      <Datagrid>
        <TextField source="id" />
        <FunctionField 
          label="Product" 
          render={record => record.product.name+" "+record.product.sku}
          sortBy="product"
        />
        <NumberField source="quantity" label="Quantity" />
        <FunctionField
          label="Supplier"
          source="supplier"
          render={(record) =>
            StockSupplierEnum.find((x) => x.id === record.supplier)?.name
          }
          sortBy="supplier"
        />
        <TextField source="warehouse" label="Warehouse" />
        <FunctionField
          label="Type"
          source="type"
          render={(record) =>
            StockTypeEnum.find((x) => x.id === record.type)?.name
          }
          sortBy="type"
        />
        <DateField source="incoming_at" label="Incoming At"/>
        <DateField source="created_at" label="Created At" showTime/>
        <BooleanField source="is_latest"label="" />
        <IfCanAccess action="edit">
            <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
